<div
  class="accordion-container d-flex flex-row flex-nowrap grid partial-grid container"
  [class.flex-row-reverse]="imageOnRight"
  [class.justify-content-center]="isNarrow"
  >
  <!-- Desktop Image Container -->
  <div class="accordion-image-container">
    <div
      class="accordion-image-container-background px-4"
            [@colorChange]="{
                value: colorChangeState,
                params: { backgroundColor: currentBackgroundColor, nextBackgroundColor: nextBackgroundColor }
            }"
      >
      <img
        [class]="'accordion-image accordion-image-' + uniqueIndex"
        [ngClass]="subImgState == 'visible' ? 'accordion-image-visible' : 'accordion-image-hidden'"
        #desktopAccordionImage
        [src]="currentImage !== '' ? currentImage : mainImage"
        [attr.loading]="isBrowser ? 'lazy' : null"
        />
    </div>
    <img
      class="accordion-image accordion-image-new"
      #accordionImage
      [src]="newCurrentImage !== '' ? newCurrentImage : mainImage"
      [@imgChange]="imgState"
      [ngStyle]="{ 'max-width': currentImageSize }"
      [attr.loading]="isBrowser ? 'lazy' : null"
      />
  </div>

  <!-- Title, body, & instances -->
  <div [id]="'partialAccordion-' + uniqueIndex" class="accordion-content-container">
    <!-- Main Title & body -->
    @if (mainTitle || mainBody) {
      <div class="accordion-content-container-main">
        @if (mainSubtitle) {
          <h4 class="accordion-label mb-base mt-0">
            {{ mainSubtitle }}
          </h4>
        }
        <h2 class="accordion-title mb-3">{{ mainTitle }}</h2>
        <div
          class="accordion-mainbody"
          [ngClass]="(mainButtonLinkTitle && mainButtonLink) || mainButtonMarketoFormSelection !== 'no_form' ? 'mt-3 mb-0' : 'my-3'"
          >
          @if (mainBody) {
            <div [innerHTML]="mainBody | safe: 'html'"></div>
          }
        </div>
        <!-- Button Link -->
        @if (mainButtonLinkTitle && mainButtonLink) {
          <a [href]="mainButtonLink" class="accordion-mainlink d-flex fx-row-h-center mt-2 mb-3">
            <span>{{ mainButtonLinkTitle }}</span>
            <mat-icon svgIcon="chevron_right"></mat-icon>
          </a>
        }
        <!-- Button Marketo Form -->
        @if (mainButtonMarketoFormSelection !== 'no_form') {
          <button
            class="accordion-mainform d-flex fx-row-h-center mt-2 mb-3"
                (click)="
                    bootstrapMarketoService.openBootstrapMarketoDialog(mainButtonMarketoFormID.toString(), 'edit', {
                        title: dataTitle,
                        url: dataUrl
                    })
                "
            >
            <span>{{ mainButtonLinkTitle }}</span>
            <mat-icon svgIcon="chevron_right"></mat-icon>
          </button>
        }
      </div>
    }

    <!-- Tablet & Mobile Image -->
    @if (mainTitle || mainBody) {
      <div class="accordion-image-container-tablet mb-3" [ngStyle]="{ 'background-color': backgroundColor }">
        <img
          class="accordion-image-tablet"
          [ngClass]="subImgState == 'visible' ? 'accordion-image-visible' : 'accordion-image-hidden'"
          #accordionImage
          [src]="currentImage !== '' ? currentImage : mainImage"
          [attr.loading]="isBrowser ? 'lazy' : null"
          />
        <img
          class="accordion-image-tablet accordion-image-tablet-new"
          #accordionImage
          [src]="newCurrentImage !== '' ? newCurrentImage : mainImage"
          [@imgChange]="imgState"
          [attr.loading]="isBrowser ? 'lazy' : null"
          />
      </div>
    }

    <!-- Instances (Accordion Items) -->
    <span class="accordion-item-container">
      @for (accordion of instances; track accordion; let i = $index) {
        <div
          class="accordion-item"
          #accordionItem
                [ngClass]="
                    !(!mainTitle && !mainBody)
                        ? i == currentAccordion
                            ? 'accordion-is-open'
                            : 'accordion-is-closed'
                        : i == currentAccordion
                        ? 'accordion-is-open-with-image'
                        : 'accordion-is-closed-with-image'
                "
          id="{{ 'accordion-item-' + uniqueIndex + i }}"
          [ngStyle]="mainTitle == '' && i == 0 && currentAccordion == 0 && { 'border-top': 'none' }"
          (click)="setAccordion(i)"
          >
          <div class="accordion-item-header-container" id="{{ 'headingImageAndText-' + uniqueIndex + i }}">
            <div class="accordion-item-button d-flex fx-col-h-left p-0"
                 role="button"
                 [attr.aria-expanded]="i === currentAccordion"
                 tabindex="0"
                 (keydown.enter)="setAccordion(i); $event.preventDefault()"
                 (keydown.space)="setAccordion(i); $event.preventDefault()">
              <!-- Subheader -->
              @if (accordion?.subheader) {
                <h5
                  class="accordion-item-label"
                  [ngClass]="i === currentAccordion ? 'subheader-visible' : (isInitialized ? 'subheader-hidden' : 'subheader-hidden-no-anim')"
                  >
                  {{ accordion?.subheader }}
                </h5>
              }
              <!-- Header -->
              <span class="d-flex fx-row-h-space-between align-items-center w-100">
                <span class="accordion-item-title">{{ accordion?.header }}</span>
                <span class="accordion-item-chevron d-flex">
                  <mat-icon
                    svgIcon="chevron_down"
                    [@accordionChange]="i == currentAccordion ? 'chevron_up' : 'chevron_down'"
                  ></mat-icon>
                </span>
              </span>
            </div>
          </div>
          <div
            id="{{ 'collapseAccordion-' + uniqueIndex + i }}"
            class="accordion-collapse"
            [attr.inert]="i !== currentAccordion ? '' : null"
            [ngClass]="i === currentAccordion ? 'body-visible' : (isInitialized ? 'body-hidden' : 'body-hidden-no-anim')"
            >
            <div class="accordion-item-body p-0">
              <!-- Body Copy -->
              <div class="accordion-item-copy">
                <div [innerHTML]="accordion?.body_copy | safe: 'html'"></div>
              </div>
            </div>
            <!-- Image to display if no body content is set (Tablet & Mobile) -->
            @if (!mainTitle && !mainBody) {
              <div
                class="accordion-image-container-tablet mb-1 mt-3"
                [ngStyle]="{ 'background-color': backgroundColor }"
                >
                <img
                  class="accordion-image-tablet"
                  [ngClass]="subImgState == 'visible' ? 'accordion-image-visible' : 'accordion-image-hidden'"
                  #accordionImage
                  [src]="currentImage !== '' ? currentImage : mainImage"
                  [attr.loading]="isBrowser ? 'lazy' : null"
                  />
                <img
                  class="accordion-image-tablet accordion-image-tablet-new"
                  #accordionImage
                  [src]="newCurrentImage !== '' ? newCurrentImage : mainImage"
                  [@imgChange]="imgState"
                  [attr.loading]="isBrowser ? 'lazy' : null"
                  />
              </div>
            }
          </div>
        </div>
      }
    </span>
  </div>
</div>
